import {
    formatDateToDateString,
    formatHoursToTimeFormat,
    formatMinutesToTimeFormat,
    getMonthDays,
    longDateFormat
} from "@components/inputs/date/utils";
import { IColumn, IRow } from "@components/table";
import { isRowValueCellValueObject } from "@components/table/TableUtils";
import { IPrAttendanceDayEntity, IPrAttendanceEntity } from "@odata/GeneratedEntityTypes";
import { IntervalType } from "@pages/payroll/attendance/Attendance.types";
import React, { Component } from "react";

import SimpleTable from "../../../components/simpleTable";
import { TextAlign } from "../../../enums";
import { ColoredText } from "../../../global.style";
import DateType, { getDateFormat, getUtcDayjs } from "../../../types/Date";
import { FormStorage } from "../../../views/formView/FormStorage";
import { balanceFormatter, getDayIntervalsMinutes } from "./Attendance.utils";
import { IAttendanceCustomData } from "./AttendanceFormView";

interface IProps {
    storage: FormStorage<IPrAttendanceEntity, IAttendanceCustomData>;
    saldoMap: Record<number, number>;
}

export default class AttendanceDaysList extends Component<IProps> {
    get columns(): IColumn[] {
        return [
            { id: "day", label: this.props.storage.t("Attendance:DaysList.Day"), textAlign: TextAlign.Left },
            { id: "fund", label: this.props.storage.t("Attendance:DaysList.Fund"), textAlign: TextAlign.Right },
            { id: "worked", label: this.props.storage.t("Attendance:DaysList.Worked"), textAlign: TextAlign.Right },
            { id: "saldo", label: this.props.storage.t("Attendance:DaysList.Saldo"), textAlign: TextAlign.Right },
            { id: "start", label: this.props.storage.t("Attendance:DaysList.Start"), textAlign: TextAlign.Right },
            { id: "end", label: this.props.storage.t("Attendance:DaysList.End"), textAlign: TextAlign.Right },
            { id: "absence", label: this.props.storage.t("Attendance:DaysList.Absence"), textAlign: TextAlign.Right }
        ];
    }

    get rows(): IRow[] {
        const storage = this.props.storage;
        const entity = storage.data.entity as IPrAttendanceEntity;
        const date = getUtcDayjs().set("month", entity.Month - 1).set("year", entity.Year);

        const days = getMonthDays(date);

        const mappedWorkDays = entity.Days?.reduce((map: Record<string, IPrAttendanceDayEntity>, day) => {
            map[formatDateToDateString(day.Date)] = day;
            return map;
        }, {}) ?? {};

        return days.map(d => {
            const data = mappedWorkDays[formatDateToDateString(d.toDate())];

            const dayIndex = d.get("date");
            const workedMinutes = getDayIntervalsMinutes(data, IntervalType.Work);
            const absenceMinutes = getDayIntervalsMinutes(data, IntervalType.Absence);

            const start = data?.Intervals?.[0]?.TimeStart;
            const end = data?.Intervals?.[data?.Intervals?.length - 1]?.TimeEnd;
            const formattedBalance = balanceFormatter(this.props.saldoMap[dayIndex], { storage });
            const saldo = (isRowValueCellValueObject(formattedBalance) ? formattedBalance.value : formattedBalance) as string;
            const h = storage.t("Components:Calendar.HourPlaceholder");

            return {
                id: dayIndex,
                values: {
                    day: `${d.format("dd").toUpperCase() } ${DateType.format(d.toDate())}`,
                    fund: `${formatMinutesToTimeFormat(data?.Planned ?? 0)} ${h}`,
                    saldo,
                    worked: `${formatMinutesToTimeFormat(workedMinutes)} ${h}`,
                    absence: {
                        value: <ColoredText
                            color={absenceMinutes > 0 ? "C_SEM_text_warning" : "C_TEXT_primary"}>{`${formatMinutesToTimeFormat(absenceMinutes)} ${h}`}</ColoredText>,
                        tooltip: `${formatMinutesToTimeFormat(absenceMinutes)} ${h}`
                    },
                    start: start ? DateType.format(start, longDateFormat(getDateFormat(DateType.defaultTimeFormat))) : formatHoursToTimeFormat(0),
                    end: start ? DateType.format(end, longDateFormat(getDateFormat(DateType.defaultTimeFormat))) : formatHoursToTimeFormat(0),

                },
                isDisabled: !data
            };
        });
    }

    render() {
        return <SimpleTable
            columns={this.columns}
            rows={this.rows}
        />;
    }
}